import { useDispatch } from 'react-redux';
import { clearAccountRmas } from '@client/myAccount/rma/redux/rmas/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useClearRmasAction = (): typeof clearAccountRmas => {
  const dispatch = useDispatch();

  return bindActionCreators(clearAccountRmas, dispatch);
};
